/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import { Card } from '@pareto-engineering/design-system'

import styleNames from '@pareto-engineering/bem/exports'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const wrapperClassName = 'solution-card-wrapper'

const componentClassName = 'solution-card'

/**
 * This is the component description.
 */
const SolutionCard = ({
  id,
  className: userClassName,
  style,
  title,
  description,
  path,
  arrowPosition,
}) => (
  <Link
    to={path}
    className={[
      baseClassName,
      wrapperClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
  >
    <Card
      id={id}
      className={[
        baseClassName,
        componentClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      <Card.Section className="body">
        <p className="title">
          {title}
          {arrowPosition === 'top' && (
            <span className="icon s-2">
              M
            </span>
          )}
        </p>
        {description && (
          <p>{description}</p>
        )}
      </Card.Section>
      {arrowPosition === 'bottom' && (
        <Card.Section className="bottom">
          <p className="icon s-2">M</p>
        </Card.Section>
      )}
    </Card>
  </Link>
)

SolutionCard.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The card title
   */
  title:PropTypes.string,

  /**
   * The card url
   */
  path:PropTypes.string,

  /**
   * The card arrow position
   * */
  arrowPosition:PropTypes.oneOf(['top', 'bottom']),

  /**
   * The solution description
   * */
  description:PropTypes.string,
}

SolutionCard.defaultProps = {
  arrowPosition:'top',
}

SolutionCard.Group = Card.Group

export default SolutionCard
